import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { useTheme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Backdrop,
  CircularProgress,
  Slide,
  Typography,
  useScrollTrigger,
} from "@material-ui/core";
import "./CarList.css";

import actions from "../actions";

//import {APIKEY, BUILDING_ID} from '../config.json';

const oldSTART = {
  x: 129.06409616919393,
  y: 117.14565043894652,
  map_id: 131,
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    paddingTop: '9.5%',
    overflow: 'hidden',
  },
  paper: {
    position: "relative",
    overflowY: "scroll",
    width: '68%',
    height: '100%',
    marginTop: '6.6%',
    alignContent: 'flex-start',
  },
  card: {
    display: 'flex',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    overflow: "hidden",
    marginBottom: '3%',
    [theme.breakpoints.down('sm')]: {
      width: '120px',
      height: '90px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '222px',
      height: '167px',
    },
    [theme.breakpoints.up('md')]: {
      width: '400px',
      height: '300px',
    },
  },
  appBar: {
    width: "100%",
    position: "absolute",
    top: 0,
  },
  error: {
    marginTop: "30%",
  },
}));

const useFetchCarList = (carNumber, type, apikey, building_code) => {
  const [carList, setCarList] = useState([]);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState(null);

  const API_URL =
    "https://analytics.sto-tek.com/_nodered/api/callExternalAPI?apiKey=" +
    apikey +
    "&EAPI=API_Building_02&buildingID=" +
    building_code +
    "&s=" +
    carNumber +
    "&m=" +
    type +
    "&p=0";

  /* m=pnr : 車格  m=lpr: 車牌 */
  /* p-0 模糊搜尋 p=1 精準 */

  useEffect(() => {
    setComplete(false);
    setError(null);

    fetch(API_URL)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        setComplete(true);
        if (json.data) {
          setCarList(json.data);
        } else {
          setCarList([]);
        }
      })
      .catch((err) => {
        setComplete(true);
        setError(err);
      });
  }, []);
  return { carList, complete, error };
};

const useFetchAllFloor = (apikey, building_id) => {
  const [floorData, setFloorData] = useState([]);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState(null);

  const GET_POIS_API =
    "https://stoparking.sto-tek.com/api/getpois?building=" +
    building_id +
    "&floor=all&apiKey=" +
    apikey;

  useEffect(() => {
    setComplete(false);
    setError(null);

    fetch(GET_POIS_API)
      .then((res) => res.json())
      .then((json) => {
        setComplete(true);
        setFloorData(json.info);
      })
      .catch((err) => {
        setComplete(true);
        setError(err);
      });
  }, [building_id]);
  return { floorData, complete, error };
};

const useFindStartPoint = (kiosk_poi_id, floorData) => {
  var startPoint = {
    PosX: 0.0,
    PosY: 0.0,
    map_id: undefined,
  };
  var targetMapId = undefined;
  var targetFloorName = "";
  var targetPoi = undefined;
  const dispatch = useDispatch();
  const findPoiDetail = (kiosk_poi_id, floorData) => {
    if (
      floorData.find((element) => {
        return parseInt(element.id) === kiosk_poi_id;
      })
    ) {
      return true;
    }
    return false;
  };
  const targetFloor = floorData.find((floor) => {
    return findPoiDetail(kiosk_poi_id, floor.PoiDetail);
  });
  if (targetFloor) {
    targetMapId = parseInt(targetFloor.MapID);
    targetFloorName = targetFloor.Name;
    targetPoi = targetFloor.PoiDetail.find((element) => {
      return parseInt(element.id) === kiosk_poi_id;
    });
    startPoint = {
      PosX: targetPoi.PosX,
      PosY: targetPoi.PosY,
      map_id: targetMapId,
      floorName: targetFloorName,
    };
    dispatch({ type: actions.SET_START_POINT, startPoint: startPoint });
  }
  return startPoint;
};

function NoResult(props) {
  const classes = useStyles();
  return (
    <Grid className={classes.paper}>
      <Typography
        variant="h1"
        align="center"
        color="error"
        className={classes.error}
      >
        <FormattedMessage id="carlist.search_no_result"
          defaultMessage="找不到車輛" />
      </Typography>
    </Grid>
  );
}

function HideOnScroll(props) {
  const { children, trigger, carList } = props;
  const CARLIST_OVERFLOW_THREHOLD = 6;
  const barAppear = carList.length > CARLIST_OVERFLOW_THREHOLD ? true : false;
  return (
    <Slide direction="down" in={!trigger && barAppear}>
      {children}
    </Slide>
  );
}

function CarListCard(props) {
  const classes = useStyles(useTheme());
  const history = useHistory();
  const location = useLocation();
  const { carList } = props;
  const KioskPoiId = useSelector((state) => state.KIOSK_POI_ID);
  const APIKEY = useSelector((state) => state.apikey);
  const BUILDING_ID = useSelector((state) => state.buildingId);
  const floorHook = useFetchAllFloor(APIKEY, BUILDING_ID);
  const floorData = floorHook.floorData;
  const naviSTART = useFindStartPoint(KioskPoiId, floorData);
  const [scrollTarget, setScrollTarget] = useState(undefined);
  const trigger = useScrollTrigger({ target: scrollTarget });

  const sendCollectData = (data) => {
    const COLLECT_API_URL = 'https://analytics.sto-tek.com/_nodered/api/statistic/pathPlan';
    const reqOption = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(data),
    }
    fetch(COLLECT_API_URL, reqOption);
  }

  if (carList.length === 0) {
    return <NoResult />;
  } else {
    return (
      <div className={classes.root}>
        <span className="choosecar">請選擇您的車輛</span>
        <Grid
          container
          justify="flex-start"
          alignItems="center"
          className={classes.paper}
          columns={2}
        >
          {carList.map((car) => {
            return (
              <Grid item key={car.STOLOT} sm={6}>
                <div className={classes.card}
                  onClick={() => {
                    floorData.forEach((floor) => {
                      const poiIndex = floor.PoiDetail.findIndex((poi) => {
                        return poi.name === car.STOLOT;
                      });
                      if (poiIndex !== -1) {
                        const poi = floor.PoiDetail[poiIndex];
                        const pointData = {
                          startX: naviSTART.PosX,
                          startY: naviSTART.PosY,
                          startZ: naviSTART.map_id,
                          startFloor: naviSTART.floorName, //
                          endX: poi.PosX,
                          endY: poi.PosY,
                          endZ: floor.MapID,
                          endFloor: floor.Name,
                        };
                        const collectData = {
                          apikey: APIKEY,
                          start_poi_id: KioskPoiId,
                          start_poi_name: 'KIOSK查詢機',
                          start_x: naviSTART.PosX,
                          start_y: naviSTART.PosY,
                          start_map: naviSTART.map_id,
                          end_poi_id: poi.id,
                          end_poi_name: poi.name,
                          end_x: poi.PosX,
                          end_y: poi.PosY,
                          end_map: floor.MapID,
                        };
                        sendCollectData(collectData);
                        history.push("/MapView", {
                          ...location.state,
                          pointData,
                          carInfo: car,
                        });
                      }
                    });
                  }}
                >
                  <table>
                    <tr>
                      <td rowspan='2'>
                        <span className="platenumber">{car.LicensePlate}</span>
                      </td>
                      <td>
                        <span className="lotnumber">{car.Floor}</span>
                      </td>
                    </tr>
                    <tr>
                      <span className="lotnumber">{car.ParkingNumber}</span>
                    </tr>
                  </table>
                  <img
                    id={"car-" + car.LicensePlate}
                    src={car.PictureLink}
                    alt={car.LicensePlate}
                    className={classes.media}
                  />
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

function CarList(props) {
  const classes = useStyles();
  const location = useLocation();

  const { carNumber, type, apikey, building_id, building_code } =
    location.state;
  const { carList, complete, error } = useFetchCarList(
    carNumber,
    type,
    apikey,
    building_code
  );
  return (
    <div style={{ height: '90%' }}>
      {complete ? <CarListCard carList={carList} /> : <CircularProgress />}
    </div>
  );
}

export default CarList;
